import axiosInstanceNode from "@/api/axiosInstanceNode";

export const fetchMicrosoftConversationsStatusApi = async () => {
  const { data } = await axiosInstanceNode.get("/auth/microsoft/conversations/status");
  return data;
};

export const fetchMicrosoftConversationsAuthUrlApi = async ({
  returnPath,
  scopeMode = "core",
}) => {
  const { data } = await axiosInstanceNode.get("/auth/microsoft/conversations/auth-url", {
    params: { returnPath, scopeMode },
  });
  return data;
};

export const fetchMicrosoftAdminConsentUrlApi = async ({ returnPath }) => {
  const { data } = await axiosInstanceNode.get(
    "/auth/microsoft/conversations/admin-consent-url",
    { params: { returnPath } }
  );
  return data;
};

export const fetchAccountConversationsBootstrapApi = async ({
  companyName,
  signal,
}) => {
  const encoded = encodeURIComponent(companyName);
  const { data } = await axiosInstanceNode.get(
    `/accounts/${encoded}/conversations/bootstrap`,
    { signal },
  );
  return data;
};

export const fetchAccountInteractionsApi = async ({
  companyName,
  sourceType,
  contactId,
  limit = 50,
  offset = 0,
}) => {
  const encoded = encodeURIComponent(companyName);
  const { data } = await axiosInstanceNode.get(`/accounts/${encoded}/interactions`, {
    params: {
      sourceType,
      contactId,
      limit,
      offset,
    },
  });
  return data;
};

export const fetchAccountInteractionsSummaryApi = async ({
  companyName,
  forceRefresh = false,
}) => {
  const encoded = encodeURIComponent(companyName);
  const { data } = await axiosInstanceNode.get(
    `/accounts/${encoded}/interactions/summary`,
    {
      params: forceRefresh ? { forceRefresh: true } : undefined,
    }
  );
  return data;
};

export const fetchInteractionTranscriptApi = async ({ interactionId }) => {
  const { data } = await axiosInstanceNode.get(
    `/accounts/interactions/${interactionId}/transcript`,
    { skipGlobalErrorToast: true }
  );
  return data;
};
